module.exports = __webpack_public_path__ + "img/netgear_pic1.95adc2a0.png";